import * as React from 'react';
import { Controller, Toolbar, IActionPointInfo, ActionPointInfo, Menu, Loader, IDynamicLoader } from '@tencent/workbench';
import { FillColorFeature } from './fill-color-feature';
import { TOOLBAR_ITEMS, config, MENU_CONFIGS } from './config';
import { wrapIdForCommon, wrapIdForPic, wrapIdForText } from '@framework/workbench/util/wrap-id-util';
import {
    TDWActionType,
    TDWVer6Type,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class FillColorController {
    constructor(private readonly feature: FillColorFeature) {
    }

    @Toolbar(config.id, 'onClick')
    @Toolbar(wrapIdForText(config.id), 'onClick')
    @Toolbar(wrapIdForCommon(config.id), 'onClick')
    public onClick() {
        this.feature.onClick();
    }

    @Toolbar(config.id, 'onArrowClick')
    @Toolbar(wrapIdForText(config.id), 'onArrowClick')
    @Toolbar(wrapIdForCommon(config.id), 'onArrowClick')
    public showPalettePanel(@ActionPointInfo() info:  IActionPointInfo) {
    }

    @Toolbar(config.id, 'color')
    @Toolbar(wrapIdForText(config.id), 'color')
    @Toolbar(wrapIdForCommon(config.id), 'color')
    public getColor() {
        return this.feature.getColor();
    }

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForText(config.id), 'dropdownContent')
    @Toolbar(wrapIdForCommon(config.id), 'dropdownContent')
    public renderFontColorPicker() {
        return this.feature.getColorDropDownContent(TDWVer6Type.COLOR_PICKER_TOOLBAR);
    }

    @Menu(config.id, 'content')
    public renderFontColorPickerContent() {
        return this.feature.getColorDropDownContent(TDWVer6Type.COLOR_PICKER_TITLE);
    }
}
